// import React, { useRef, useState, useEffect } from 'react'

// import { FaTag } from "react-icons/fa";
// import WhatsAppButton from './WhatsAppButton';
// import GuidePopup from './Guidepopup';
// import GuidePopupPayment from './GuidePopupPayment';
// import { FaWhatsapp } from "react-icons/fa";
// import { useAuth } from '../../context/auth';
// import SEO from '../SEO';
// import { createPaymentLinkService } from '../apiservice/createPaymentLinkService';
// import { toast } from 'react-toastify';
// import { getHistoryDataService } from '../apiservice/getHistoryDataService';
// import { FiRefreshCcw } from 'react-icons/fi';

// const Payment = () => {

//   const data = [
//     { id: 1, action: "Login", user: "Alice", status: "Success", time: "2025-07-30 09:20" },
//     { id: 2, action: "Reset Password", user: "Bob", status: "Failed", time: "2025-07-29 16:45" },
//     { id: 3, action: "Update Profile", user: "Charlie", status: "Success", time: "2025-07-28 14:10" },
//     { id: 4, action: "Logout", user: "Daisy", status: "Success", time: "2025-07-28 10:22" },
//   ]

//   const plans = [
//     {
//       name: "FREE",
//       features: [
//         "NSE / BSE",
//         "UNLIMITED STRATEGIES",
//         "UNLIMITED TRADE",
//         "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
//         "SINGLE TAKE PROFIT / STOP LOSS.",
//         "ALERTS ARE ACCEPTED WITH A MINIMUM GAP OF 10 MINUTES.",
//         "TRADE COPIER FEATURE IS NOT AVAILABLE.",
//         "COPIER CLIENT MANAGEMENT DASHBOARD IS NOT AVAILABLE.",
//         "MAXIMUM POSITION → 5",
//         "24/7 CUSTOMER SUPPORT"
//       ],
//     },
//     {
//       name: "SILVER",
//       features: [
//         "NSE / BSE",
//         "UNLIMITED STRATEGIES",
//         "UNLIMITED TRADE",
//         "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
//         "+ BREAKEVEN / TRAILING STOP.",
//         "ALERTS ARE ACCEPTED WITH A MINIMUM GAP OF 10 SECONDS.",
//         "TREADE COPIER ACCESSED ONLY BY AN INVITATION LINK.",
//         "TRADE COPIER FEATURE IS AVAILABLE WITH A LIMIT OF UP TO 5 CLIENTS.",
//         "COPIER CLIENT MANAGEMENT DASHBOARD IS AVAILABLE.",
//         "MAXIMUM POSITION → 10",
//         "24/7 CUSTOMER SUPPORT",
//       ],
//     },
//     {
//       name: "GOLD",
//       features: [
//         "NSE / BSE",
//         "UNLIMITED STRATEGIES",
//         "UNLIMITED TRADE",
//         "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
//         "+ BREAKEVEN / TRAILING STOP",
//         "ALERTS ARE ACCEPTED WITHOUT ANY TIME GAP.",
//         "TREADE COPIER ACCESSED ONLY BY AN INVITATION LINK.",
//         "TRADE COPIER FEATURE IS AVAILABLE WITH A LIMIT OF UP TO 10.",
//         "COPIER CLIENT MANAGEMENT DASHBOARD IS AVAILABLE.",
//         "MAXIMUM POSITION → 15",
//         "24/7 CUSTOMER SUPPORT",
//       ],
//     },
//     {
//       name: "DIAMOND",
//       features: [
//         "NSE / BSE",
//         "UNLIMITED STRATEGIES",
//         "UNLIMITED TRADE",
//         "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
//         "+ BREAKEVEN / TRAILING STOP.",
//         "ALERTS ARE ACCEPTED WITHOUT ANY TIME GAP.",
//         "TREADE COPIER ACCESSED ONLY BY AN INVITATION LINK.",
//         "TRADE COPIER FEATURE IS AVAILABLE WITH NO LIMITS.",
//         "COPIER CLIENT MANAGEMENT DASHBOARD IS AVAILABLE.",
//         "MAXIMUM POSITION → 20",
//         "24/7 CUSTOMER SUPPORT",
//       ],
//     },
//   ];

//   const [open, setOpen] = useState(false);
//   const [open1, setOpen1] = useState(false);
//   const [open2, setOpen2] = useState(false);
//   const [coupon, setCoupon] = useState("")
//   const [activeTab, setActiveTab] = useState("plans")
//   const popupRef = useRef(null);
//   const popupRef1 = useRef(null);
//   const popupRef2 = useRef(null);

//   const [subscriptionId, setSubscriptionId] = useState("DIAMOND");
//   const [forMonth, setForMonth] = useState(1);
//   const [loading, setLoading] = useState(false);

//   const { getLoginToken, getGoogleAuthToken } = useAuth();
//   const token = getLoginToken() || getGoogleAuthToken();
  
//   const handleSubmit = async () => {
//     const data = {
//       subscription_id: subscriptionId,
//       for_month: Number(forMonth),
//     };

//     const token = getLoginToken() || getGoogleAuthToken();

//     try {
//       setLoading(true);

//       const response = await createPaymentLinkService(token, data);

//       if (response.status === 200 && !response.data?.error) {
//         const paymentLink = response.data?.data;

//         toast.success("Redirecting to payment...");
//         window.location.href = paymentLink;

//       } else {
//         toast.error(response.data?.data || "Something went wrong");
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.error || error.message);
//       console.error("API Error:", error?.response?.data?.error || error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOpenSilver = () => {
//     setSubscriptionId("SILVER");
//     setOpen(true);
//   };

//   const handleOpenGold = () => {
//     setSubscriptionId("GOLD");
//     setOpen1(true);
//   };

//   const handleOpenDiamond = () => {
//     setSubscriptionId("DIAMOND");
//     setOpen2(true);
//   };
  
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (popupRef.current && !popupRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (popupRef1.current && !popupRef1.current.contains(event.target)) {
//         setOpen1(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (popupRef2.current && !popupRef2.current.contains(event.target)) {
//         setOpen2(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const phoneNumber = "8684953093";
//   const { getLoginMail } = useAuth()
//   const userMail = getLoginMail;
//   const message = `Hello!:${userMail}`;

//   const handleWhatsappClick = () => {
//     const url = "https://wa.me/918684953093?text=Hi";
//     window.open(url, "_blank");
//   };

//   const handleCouponChange = (e) => {
//     const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
//     setCoupon(value)
//   }

//   const [historyData, setHistoryData] = useState([]);
//   const [error, setError] = useState("");

//   const handleRefresh = () => {
//     fetchHistory()
//   }

//   const fetchHistory = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const response = await getHistoryDataService(token);

//       if (response.status === 200) {
//         if (response.success && response.data?.data) {
//           setHistoryData(response.data?.data);
//         } else {
//           console.log("error", response.data?.data?.detail)
//           console.log("error", response.data?.detail)
//           console.log("error", response?.detail)
//           setError(response.data?.data || response.message || "No history found");
//         }
//       }
//     } catch (err) {
//       setError(err.message || "Unexpected error occurred");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchHistory();
//     const interval = setInterval(fetchHistory, 30000);
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     // console.log("Updated historyData:", historyData);
//   }, [historyData]);

//   return (
//     <div className='h-screen'>
//       {/* Updated Button Section with Animations */}
//       <div className='flex justify-start px-4'>
//         <div className="fixed inset-0 pointer-events-none overflow-hidden">
//         <div className="absolute top-20 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-200/40 to-purple-200/40 dark:from-blue-500/20 dark:to-purple-500/20 rounded-full blur-3xl animate-pulse-glow"></div>
//         <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-gradient-to-r from-pink-200/40 to-orange-200/40 dark:from-pink-500/20 dark:to-orange-500/20 rounded-full blur-3xl animate-pulse-glow animation-delay-2000"></div>
//         <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-blue-100/20 to-purple-100/20 dark:from-blue-500/10 dark:to-purple-500/10 rounded-full blur-3xl"></div>
//       </div>

//         <div className="flex justify-between w-full items-center space-x-1 md:space-x-0">
//           <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
//             <button
//               onClick={() => setActiveTab("plans")}
//               className={`relative flex items-center justify-center gap-2 px-12 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
//                 activeTab === "plans"
//                   ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/40 glow-button"
//                   : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
//               }`}
//             >
//               {activeTab === "plans" && (
//                 <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-600 animate-pulse-glow opacity-50 shine-effect"></span>
//               )}
//               <span className="relative z-10">PLANS</span>
//             </button>
//           </div>

//           <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
//             <button
//               onClick={() => setActiveTab("history")}
//               className={`relative flex items-center justify-center gap-2 px-12 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
//                 activeTab === "history"
//                   ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg shadow-purple-500/40 glow-button"
//                   : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
//               }`}
//             >
//               {activeTab === "history" && (
//                 <span className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 animate-pulse-glow opacity-50 shine-effect"></span>
//               )}
//               <span className="relative z-10">HISTORY</span>
//             </button>
//           </div>
//         </div>
//       </div>

//       {(activeTab === 'plans') && (
//         <div>
//           <div className='m-4 flex flex-col sm:flex-row justify-start gap-4'>
//             <div className='flex items-center bg-white w-full sm:w-auto border border-gray-900 dark:border-mytextdark shadow-md rounded-md'>
//               <input
//                 className='w-full focus:outline-none text-mytextlight dark:text-mytextlight p-2 bg-transparent'
//                 value={coupon}
//                 onChange={handleCouponChange}
//                 placeholder='Enter coupon Code'
//               />
//               <div className='p-1 text-gray-600'>
//                 <FaTag />
//               </div>
//             </div>

//             <div className='flex items-center shadow-md w-full sm:w-auto'>
//               <button className='w-full sm:w-auto px-4 py-2 shadow-md rounded-md border bg-blue-500 text-white'>
//                 Apply
//               </button>
//             </div>
//           </div>

//           <div className="bg-transparent py-2 px-4 sm:px-6 lg:px-20">
//             <div className="max-w-7xl mx-auto flex justify-center">
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 w-full gap-y-4">
//                 {plans.map((plan, index) => (
//                   <div
//                     key={index}
//                     className="w-[80%] sm:w-[60%] md:w-[90%] mx-auto bg-white/60 dark:bg-[#1d1d1f] backdrop-blur-md rounded-xl border border-black/20 shadow-[0_0_10px_rgba(0,0,0,0.2)]"
//                   >
//                     <h2 className="text-2xl font-bold text-center m-4 text-mytextlight dark:text-mytextdark">{plan.name}</h2>

//                     <ul className="space-y-4 text-[10px] font-semibold text-center w-fit m-0">
//                       {plan.features.map((feature, idx) => (
//                         <li key={idx} className="w-full text-mytextlight m-0 border-black/40 text-md sm:text-sm md:text-md xl:text-md flex justify-center items-start text-center">
//                           <span className="mr-2 text-[14px] mt-3 text-mytextlight dark:text-mytextdark">•</span>
//                           <div className="w-full text-mytextlight dark:text-mytextdark py-3 mr-6 border-t border-gray-600">
//                             {feature}
//                           </div>
//                         </li>
//                       ))}
//                     </ul>

//                     {(index === 0) && (
//                       <div className='m-4'>
//                         <div className="text-blue-700 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
//                           ₹ 0.0
//                         </div>
//                         <button className="mt-6 w-full bg-white/60 shadow-2xl hover:bg-blue-500 text-black py-2 border rounded transition">
//                           SIGN UP
//                         </button>
//                       </div>
//                     )}

//                     {(index === 1) && (
//                       <div className='m-4 relative'>
//                         <div className="text-blue-700 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
//                           ₹ 199/-
//                         </div>
//                         <button onClick={handleOpenSilver} className="mt-6 w-full shadow-2xl bg-white/60 hover:bg-blue-500 text-black py-2 border rounded transition">
//                           BUY NOW
//                         </button>
//                       </div>
//                     )}

//                     {(index === 2) && (
//                       <div className='m-4 relative z-[9999]'>
//                         <div className="text-blue-700 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
//                           ₹ 499/-
//                         </div>
//                         <button onClick={handleOpenGold} className="mt-6 w-full bg-white/60 hover:bg-blue-500 shadow-2xl text-black py-2 border rounded transition">
//                           BUY NOW
//                         </button>
//                       </div>
//                     )}

//                     {(index === 3) && (
//                       <div className='m-4 relative'>
//                         <div className="text-blue-700 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
//                           ₹ 999/-
//                         </div>
//                         <button onClick={handleOpenDiamond} className="mt-6 w-full shadow-2xl bg-white/60 hover:bg-blue-500 text-black py-2 border rounded transition">
//                           BUY NOW
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 ))}

//                 <div>
//                   {open && (
//                     <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black/30">
//                       <div
//                         ref={popupRef}
//                         className="w-[350px] backdrop-blur-3xl shadow-2xl bg-white/50 dark:bg-[#1d1d1f] text-gray-800 text-sm p-6 rounded-lg border border-gray-200 animate-fade-in origin-bottom transition-all duration-300"
//                       >
//                         <div className="flex justify-center mb-4">
//                           <FaWhatsapp
//                             onClick={handleWhatsappClick}
//                             className="text-4xl text-green-600 cursor-pointer hover:scale-110 transition"
//                           />
//                         </div>
//                         <div className="text-center text-sm text-mytextlight dark:text-mytextdark space-y-2 mb-4">
//                           <p>
//                             Please select your subscription plan and duration. Our team will
//                             guide you after confirmation of payment.
//                           </p>
//                         </div>
//                         <div className="space-y-4">
//                           <div>
//                             <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
//                               Subscription Plan
//                             </label>
//                             <input
//                               type="text"
//                               value={subscriptionId}
//                               onChange={(e) => setSubscriptionId(e.target.value)}
//                               className="w-full p-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500"
//                               placeholder="Enter subscription (e.g. DIAMOND)"
//                             />
//                           </div>
//                           <div>
//                             <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
//                               For Month(s)
//                             </label>
//                             <input
//                               type="number"
//                               value={forMonth}
//                               onChange={(e) => setForMonth(e.target.value)}
//                               className="w-full p-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500"
//                               placeholder="Enter number of months"
//                               min="1"
//                             />
//                           </div>
//                           <button
//                             onClick={handleSubmit}
//                             className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
//                           >
//                             Submit
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div>
//                   {open1 && (
//                     <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black/30">
//                       <div
//                         ref={popupRef1}
//                         className="w-[350px] backdrop-blur-3xl shadow-2xl bg-white/50 dark:bg-[#1d1d1f] text-gray-800 text-sm p-6 rounded-lg border border-gray-200 animate-fade-in origin-bottom transition-all duration-300"
//                       >
//                         <div className="flex justify-center mb-4">
//                           <FaWhatsapp
//                             onClick={handleWhatsappClick}
//                             className="text-4xl text-green-600 cursor-pointer hover:scale-110 transition"
//                           />
//                         </div>
//                         <div className="text-center text-sm text-mytextlight dark:text-mytextdark space-y-2 mb-4">
//                           <p>
//                             Please select your subscription plan and duration. Our team will
//                             guide you after confirmation of payment.
//                           </p>
//                         </div>
//                         <div className="space-y-4">
//                           <div>
//                             <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
//                               Subscription Plan
//                             </label>
//                             <input
//                               type="text"
//                               value={subscriptionId}
//                               onChange={(e) => setSubscriptionId(e.target.value)}
//                               className="w-full p-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500"
//                               placeholder="Enter subscription (e.g. DIAMOND)"
//                             />
//                           </div>
//                           <div>
//                             <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
//                               For Month(s)
//                             </label>
//                             <input
//                               type="number"
//                               value={forMonth}
//                               onChange={(e) => setForMonth(e.target.value)}
//                               className="w-full p-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500"
//                               placeholder="Enter number of months"
//                               min="1"
//                             />
//                           </div>
//                           <button
//                             onClick={handleSubmit}
//                             className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
//                           >
//                             Submit
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div>
//                   {open2 && (
//                     <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black/30">
//                       <div
//                         ref={popupRef2}
//                         className="w-[350px] backdrop-blur-3xl shadow-2xl bg-white/50 dark:bg-[#1d1d1f] text-gray-800 text-sm p-6 rounded-lg border border-gray-200 animate-fade-in origin-bottom transition-all duration-300"
//                       >
//                         <div className="flex justify-center mb-4">
//                           <FaWhatsapp
//                             onClick={handleWhatsappClick}
//                             className="text-4xl text-green-600 cursor-pointer hover:scale-110 transition"
//                           />
//                         </div>
//                         <div className="text-center text-sm text-mytextlight dark:text-mytextdark space-y-2 mb-4">
//                           <p>
//                             Please select your subscription plan and duration. Our team will
//                             guide you after confirmation of payment.
//                           </p>
//                         </div>
//                         <div className="space-y-4">
//                           <div>
//                             <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
//                               Subscription Plan
//                             </label>
//                             <input
//                               type="text"
//                               value={subscriptionId}
//                               onChange={(e) => setSubscriptionId(e.target.value)}
//                               className="w-full p-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500"
//                               placeholder="Enter subscription (e.g. DIAMOND)"
//                             />
//                           </div>
//                           <div>
//                             <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
//                               For Month(s)
//                             </label>
//                             <input
//                               type="number"
//                               value={forMonth}
//                               onChange={(e) => setForMonth(e.target.value)}
//                               className="w-full p-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500"
//                               placeholder="Enter number of months"
//                               min="1"
//                             />
//                           </div>
//                           <button
//                             onClick={handleSubmit}
//                             className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
//                           >
//                             Submit
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {(activeTab === "history") && (
//         <div className="overflow-x-auto p-4">
//           <div className="backdrop-blur-md bg-white/70 dark:bg-[#1d1d1f] rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px]">
//             <div className="flex justify-end items-center space-x-2 space-y-4">
//               <button
//                 onClick={handleRefresh}
//                 className="text-gray-900 dark:text-white p-2 rounded-md border border-gray-300 hover:bg-gray-100 mb-3 dark:hover:bg-blue-300 hover:text-blue-500 transition-transform duration-500 hover:rotate-180"
//                 title="Refresh"
//               >
//                 <FiRefreshCcw />
//               </button>
//             </div>

//             <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9]">
//               <thead className="bg-blue-50 text-blue-800">
//                 <tr>
//                   <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                     <div className="flex items-center justify-between gap-1">
//                       Created
//                     </div>
//                   </th>
//                   <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                     <div className="flex items-center justify-between gap-1">
//                       Payment Id
//                     </div>
//                   </th>
//                   <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                     <div className="flex items-center justify-between gap-1">
//                       Subscription Amount
//                     </div>
//                   </th>
//                   <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                     <div className="flex items-center justify-between gap-1">
//                       Month
//                     </div>
//                   </th>
//                   <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                     <div className="flex items-center justify-between gap-1">
//                       Amount
//                     </div>
//                   </th>
//                   <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                     <div className="flex items-center justify-between gap-1">
//                       Status
//                     </div>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {historyData.length === 0 ? (
//                   <tr>
//                     <td colSpan={6} className="min-w-[30px] text-center py-4 border border-[#94BBE9] text-gray-500 dark:text-black">
//                       No alerts found
//                     </td>
//                   </tr>
//                 ) : (
//                   Array.isArray(historyData) && historyData.map((row, idx) => (
//                     <tr key={idx} className="border-b border-[#94BBE9] text-mytextlight dark:text-mytextdark">
//                       <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]">
//                         {new Date(row.created).toLocaleDateString()}
//                       </td>
//                       <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]">
//                         {row.payment_id}
//                       </td>
//                       <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]">
//                         {row.subscription_amount}
//                       </td>
//                       <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]">
//                         {row.months}
//                       </td>
//                       <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]">
//                         {`${row.subscription_amount} * ${row.months} = ${row.amount}`}
//                       </td>
//                       <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]">
//                         {row.status}
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {/* <div>
//         <WhatsAppButton></WhatsAppButton>
//       </div>

//       <div>
//         <GuidePopupPayment activePaymentTab={activeTab}></GuidePopupPayment>
//       </div> */}
//     </div>
//   );
// }

// export default Payment




import React, { useRef, useState, useEffect } from 'react'

import { FaTag } from "react-icons/fa";
import WhatsAppButton from './WhatsAppButton';
import GuidePopup from './Guidepopup';
import GuidePopupPayment from './GuidePopupPayment';
import { FaWhatsapp } from "react-icons/fa";
import { useAuth } from '../../context/auth';
import SEO from '../SEO';
import { createPaymentLinkService } from '../apiservice/createPaymentLinkService';
import { toast } from 'react-toastify';
import { getHistoryDataService } from '../apiservice/getHistoryDataService';
import { FiRefreshCcw } from 'react-icons/fi';

const Payment = () => {

  const data = [
    { id: 1, action: "Login", user: "Alice", status: "Success", time: "2025-07-30 09:20" },
    { id: 2, action: "Reset Password", user: "Bob", status: "Failed", time: "2025-07-29 16:45" },
    { id: 3, action: "Update Profile", user: "Charlie", status: "Success", time: "2025-07-28 14:10" },
    { id: 4, action: "Logout", user: "Daisy", status: "Success", time: "2025-07-28 10:22" },
  ]

  const plans = [
    {
      name: "FREE",
      features: [
        "NSE / BSE",
        "UNLIMITED STRATEGIES",
        "UNLIMITED TRADE",
        "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
        "SINGLE TAKE PROFIT / STOP LOSS.",
        "ALERTS ARE ACCEPTED WITH A MINIMUM GAP OF 10 MINUTES.",
        "TRADE COPIER FEATURE IS NOT AVAILABLE.",
        "COPIER CLIENT MANAGEMENT DASHBOARD IS NOT AVAILABLE.",
        "MAXIMUM POSITION → 5",
        "24/7 CUSTOMER SUPPORT"
      ],
    },
    {
      name: "SILVER",
      features: [
        "NSE / BSE",
        "UNLIMITED STRATEGIES",
        "UNLIMITED TRADE",
        "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
        "+ BREAKEVEN / TRAILING STOP.",
        "ALERTS ARE ACCEPTED WITH A MINIMUM GAP OF 10 SECONDS.",
        "TREADE COPIER ACCESSED ONLY BY AN INVITATION LINK.",
        "TRADE COPIER FEATURE IS AVAILABLE WITH A LIMIT OF UP TO 5 CLIENTS.",
        "COPIER CLIENT MANAGEMENT DASHBOARD IS AVAILABLE.",
        "MAXIMUM POSITION → 10",
        "24/7 CUSTOMER SUPPORT",
      ],
    },
    {
      name: "GOLD",
      features: [
        "NSE / BSE",
        "UNLIMITED STRATEGIES",
        "UNLIMITED TRADE",
        "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
        "+ BREAKEVEN / TRAILING STOP",
        "ALERTS ARE ACCEPTED WITHOUT ANY TIME GAP.",
        "TREADE COPIER ACCESSED ONLY BY AN INVITATION LINK.",
        "TRADE COPIER FEATURE IS AVAILABLE WITH A LIMIT OF UP TO 10.",
        "COPIER CLIENT MANAGEMENT DASHBOARD IS AVAILABLE.",
        "MAXIMUM POSITION → 15",
        "24/7 CUSTOMER SUPPORT",
      ],
    },
    {
      name: "DIAMOND",
      features: [
        "NSE / BSE",
        "UNLIMITED STRATEGIES",
        "UNLIMITED TRADE",
        "ULTRA-FAST ALERT EXECUTION — UNDER 100MS.",
        "+ BREAKEVEN / TRAILING STOP.",
        "ALERTS ARE ACCEPTED WITHOUT ANY TIME GAP.",
        "TREADE COPIER ACCESSED ONLY BY AN INVITATION LINK.",
        "TRADE COPIER FEATURE IS AVAILABLE WITH NO LIMITS.",
        "COPIER CLIENT MANAGEMENT DASHBOARD IS AVAILABLE.",
        "MAXIMUM POSITION → 20",
        "24/7 CUSTOMER SUPPORT",
      ],
    },
  ];

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [coupon, setCoupon] = useState("")
  const [activeTab, setActiveTab] = useState("plans")
  const popupRef = useRef(null);
  const popupRef1 = useRef(null);
  const popupRef2 = useRef(null);

  const [subscriptionId, setSubscriptionId] = useState("DIAMOND");
  const [forMonth, setForMonth] = useState(1);
  const [loading, setLoading] = useState(false);

  const { getLoginToken, getGoogleAuthToken } = useAuth();
  const token = getLoginToken() || getGoogleAuthToken();
  
  const handleSubmit = async () => {
    const data = {
      subscription_id: subscriptionId,
      for_month: Number(forMonth),
    };

    const token = getLoginToken() || getGoogleAuthToken();

    try {
      setLoading(true);

      const response = await createPaymentLinkService(token, data);

      if (response.status === 200 && !response.data?.error) {
        const paymentLink = response.data?.data;

        toast.success("Redirecting to payment...");
        window.location.href = paymentLink;

      } else {
        toast.error(response.data?.data || "Something went wrong");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || error.message);
      console.error("API Error:", error?.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSilver = () => {
    setSubscriptionId("SILVER");
    setOpen(true);
  };

  const handleOpenGold = () => {
    setSubscriptionId("GOLD");
    setOpen1(true);
  };

  const handleOpenDiamond = () => {
    setSubscriptionId("DIAMOND");
    setOpen2(true);
  };
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef1.current && !popupRef1.current.contains(event.target)) {
        setOpen1(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef2.current && !popupRef2.current.contains(event.target)) {
        setOpen2(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const phoneNumber = "8684953093";
  const { getLoginMail } = useAuth()
  const userMail = getLoginMail;
  const message = `Hello!:${userMail}`;

  const handleWhatsappClick = () => {
    const url = "https://wa.me/918684953093?text=Hi";
    window.open(url, "_blank");
  };

  const handleCouponChange = (e) => {
    const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
    setCoupon(value)
  }

  const [historyData, setHistoryData] = useState([]);
  const [error, setError] = useState("");

  const handleRefresh = () => {
    fetchHistory()
  }

  const fetchHistory = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await getHistoryDataService(token);

      if (response.status === 200) {
        if (response.success && response.data?.data) {
          setHistoryData(response.data?.data);
        } else {
          console.log("error", response.data?.data?.detail)
          console.log("error", response.data?.detail)
          console.log("error", response?.detail)
          setError(response.data?.data || response.message || "No history found");
        }
      }
    } catch (err) {
      setError(err.message || "Unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
    const interval = setInterval(fetchHistory, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // console.log("Updated historyData:", historyData);
  }, [historyData]);

  return (
    <div className='h-screen bg-gray-50 dark:bg-gray-900'>
      {/* Updated Button Section with Animations */}
      <div className='flex justify-start px-4'>
        <div className="fixed inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-20 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-200/40 to-purple-200/40 dark:from-blue-500/10 dark:to-purple-500/10 rounded-full blur-3xl animate-pulse-glow"></div>
          <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-gradient-to-r from-pink-200/40 to-orange-200/40 dark:from-pink-500/10 dark:to-orange-500/10 rounded-full blur-3xl animate-pulse-glow animation-delay-2000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-blue-100/20 to-purple-100/20 dark:from-blue-500/5 dark:to-purple-500/5 rounded-full blur-3xl"></div>
        </div>

        <div className="flex justify-between w-full items-center space-x-1 md:space-x-0">
          <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
            <button
              onClick={() => setActiveTab("plans")}
              className={`relative flex items-center justify-center gap-2 px-12 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
                activeTab === "plans"
                  ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/40 glow-button"
                  : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
              }`}
            >
              {activeTab === "plans" && (
                <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-600 animate-pulse-glow opacity-50 shine-effect"></span>
              )}
              <span className="relative z-10">PLANS</span>
            </button>
          </div>

          <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
            <button
              onClick={() => setActiveTab("history")}
              className={`relative flex items-center justify-center gap-2 px-12 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
                activeTab === "history"
                  ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg shadow-purple-500/40 glow-button"
                  : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
              }`}
            >
              {activeTab === "history" && (
                <span className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 animate-pulse-glow opacity-50 shine-effect"></span>
              )}
              <span className="relative z-10">HISTORY</span>
            </button>
          </div>
        </div>
      </div>

      {(activeTab === 'plans') && (
        <div>
          {/* Coupon Input - Dark Mode Added */}
          <div className='m-4 flex flex-col sm:flex-row justify-start gap-4'>
            <div className='flex items-center bg-white dark:bg-gray-800 w-full sm:w-auto border border-gray-900 dark:border-gray-600 shadow-md rounded-md'>
              <input
                className='w-full focus:outline-none text-gray-900 dark:text-gray-300 p-2 bg-transparent placeholder-gray-500 dark:placeholder-gray-400'
                value={coupon}
                onChange={handleCouponChange}
                placeholder='Enter coupon Code'
              />
              <div className='p-1 text-gray-600 dark:text-gray-400'>
                <FaTag />
              </div>
            </div>

            <div className='flex items-center shadow-md w-full sm:w-auto'>
              <button className='w-full sm:w-auto px-4 py-2 shadow-md rounded-md border bg-blue-500 text-white hover:bg-blue-600 transition-colors duration-200'>
                Apply
              </button>
            </div>
          </div>

          {/* Plans Grid - Dark Mode Added */}
          <div className="bg-transparent py-2 px-4 sm:px-6 lg:px-20">
            <div className="max-w-7xl mx-auto flex justify-center">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 w-full gap-y-4">
                {plans.map((plan, index) => (
                  <div
                    key={index}
                    className="w-[80%] sm:w-[60%] md:w-[90%] mx-auto bg-white/60 dark:bg-gray-800/90 backdrop-blur-md rounded-xl border border-black/20 dark:border-gray-700 shadow-[0_0_10px_rgba(0,0,0,0.2)] dark:shadow-[0_0_10px_rgba(255,255,255,0.05)]"
                  >
                    <h2 className="text-2xl font-bold text-center m-4 text-gray-900 dark:text-gray-100">{plan.name}</h2>

                    <ul className="space-y-4 text-[10px] font-semibold text-center w-fit m-0">
                      {plan.features.map((feature, idx) => (
                        <li key={idx} className="w-full text-gray-700 dark:text-gray-300 m-0 border-black/40 text-md sm:text-sm md:text-md xl:text-md flex justify-center items-start text-center">
                          <span className="mr-2 text-[14px] mt-3 text-gray-700 dark:text-gray-400">•</span>
                          <div className="w-full text-gray-700 dark:text-gray-300 py-3 mr-6 border-t border-gray-300 dark:border-gray-600">
                            {feature}
                          </div>
                        </li>
                      ))}
                    </ul>

                    {(index === 0) && (
                      <div className='m-4'>
                        <div className="text-blue-700 dark:text-blue-400 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
                          ₹ 0.0
                        </div>
                        <button className="mt-6 w-full bg-white/60 dark:bg-gray-700 shadow-2xl hover:bg-blue-500 dark:hover:bg-blue-600 text-gray-900 dark:text-white py-2 border border-gray-300 dark:border-gray-600 rounded transition-all duration-200">
                          SIGN UP
                        </button>
                      </div>
                    )}

                    {(index === 1) && (
                      <div className='m-4 relative'>
                        <div className="text-blue-700 dark:text-blue-400 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
                          ₹ 199/-
                        </div>
                        <button onClick={handleOpenSilver} className="mt-6 w-full shadow-2xl bg-white/60 dark:bg-gray-700 hover:bg-blue-500 dark:hover:bg-blue-600 text-gray-900 dark:text-white py-2 border border-gray-300 dark:border-gray-600 rounded transition-all duration-200">
                          BUY NOW
                        </button>
                      </div>
                    )}

                    {(index === 2) && (
                      <div className='m-4 relative z-[9999]'>
                        <div className="text-blue-700 dark:text-blue-400 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
                          ₹ 499/-
                        </div>
                        <button onClick={handleOpenGold} className="mt-6 w-full bg-white/60 dark:bg-gray-700 hover:bg-blue-500 dark:hover:bg-blue-600 shadow-2xl text-gray-900 dark:text-white py-2 border border-gray-300 dark:border-gray-600 rounded transition-all duration-200">
                          BUY NOW
                        </button>
                      </div>
                    )}

                    {(index === 3) && (
                      <div className='m-4 relative'>
                        <div className="text-blue-700 dark:text-blue-400 font-bold text-3xl px-6 py-3 rounded-md w-fit mx-auto">
                          ₹ 999/-
                        </div>
                        <button onClick={handleOpenDiamond} className="mt-6 w-full shadow-2xl bg-white/60 dark:bg-gray-700 hover:bg-blue-500 dark:hover:bg-blue-600 text-gray-900 dark:text-white py-2 border border-gray-300 dark:border-gray-600 rounded transition-all duration-200">
                          BUY NOW
                        </button>
                      </div>
                    )}
                  </div>
                ))}

                {/* Popup for Silver - Dark Mode Added */}
                <div>
                  {open && (
                    <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black/50 dark:bg-black/70">
                      <div
                        ref={popupRef}
                        className="w-[350px] backdrop-blur-3xl shadow-2xl bg-white/90 dark:bg-gray-800/95 text-gray-800 dark:text-gray-200 text-sm p-6 rounded-lg border border-gray-200 dark:border-gray-700 animate-fade-in origin-bottom transition-all duration-300"
                      >
                        <div className="flex justify-center mb-4">
                          <FaWhatsapp
                            onClick={handleWhatsappClick}
                            className="text-4xl text-green-600 dark:text-green-500 cursor-pointer hover:scale-110 transition"
                          />
                        </div>
                        <div className="text-center text-sm text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                          <p>
                            Please select your subscription plan and duration. Our team will
                            guide you after confirmation of payment.
                          </p>
                        </div>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                              Subscription Plan
                            </label>
                            <input
                              type="text"
                              value={subscriptionId}
                              onChange={(e) => setSubscriptionId(e.target.value)}
                              className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                              placeholder="Enter subscription (e.g. DIAMOND)"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                              For Month(s)
                            </label>
                            <input
                              type="number"
                              value={forMonth}
                              onChange={(e) => setForMonth(e.target.value)}
                              className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                              placeholder="Enter number of months"
                              min="1"
                            />
                          </div>
                          <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {loading ? "Processing..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Popup for Gold - Dark Mode Added */}
                <div>
                  {open1 && (
                    <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black/50 dark:bg-black/70">
                      <div
                        ref={popupRef1}
                        className="w-[350px] backdrop-blur-3xl shadow-2xl bg-white/90 dark:bg-gray-800/95 text-gray-800 dark:text-gray-200 text-sm p-6 rounded-lg border border-gray-200 dark:border-gray-700 animate-fade-in origin-bottom transition-all duration-300"
                      >
                        <div className="flex justify-center mb-4">
                          <FaWhatsapp
                            onClick={handleWhatsappClick}
                            className="text-4xl text-green-600 dark:text-green-500 cursor-pointer hover:scale-110 transition"
                          />
                        </div>
                        <div className="text-center text-sm text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                          <p>
                            Please select your subscription plan and duration. Our team will
                            guide you after confirmation of payment.
                          </p>
                        </div>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                              Subscription Plan
                            </label>
                            <input
                              type="text"
                              value={subscriptionId}
                              onChange={(e) => setSubscriptionId(e.target.value)}
                              className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                              placeholder="Enter subscription (e.g. DIAMOND)"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                              For Month(s)
                            </label>
                            <input
                              type="number"
                              value={forMonth}
                              onChange={(e) => setForMonth(e.target.value)}
                              className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                              placeholder="Enter number of months"
                              min="1"
                            />
                          </div>
                          <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {loading ? "Processing..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Popup for Diamond - Dark Mode Added */}
                <div>
                  {open2 && (
                    <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black/50 dark:bg-black/70">
                      <div
                        ref={popupRef2}
                        className="w-[350px] backdrop-blur-3xl shadow-2xl bg-white/90 dark:bg-gray-800/95 text-gray-800 dark:text-gray-200 text-sm p-6 rounded-lg border border-gray-200 dark:border-gray-700 animate-fade-in origin-bottom transition-all duration-300"
                      >
                        <div className="flex justify-center mb-4">
                          <FaWhatsapp
                            onClick={handleWhatsappClick}
                            className="text-4xl text-green-600 dark:text-green-500 cursor-pointer hover:scale-110 transition"
                          />
                        </div>
                        <div className="text-center text-sm text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                          <p>
                            Please select your subscription plan and duration. Our team will
                            guide you after confirmation of payment.
                          </p>
                        </div>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                              Subscription Plan
                            </label>
                            <input
                              type="text"
                              value={subscriptionId}
                              onChange={(e) => setSubscriptionId(e.target.value)}
                              className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                              placeholder="Enter subscription (e.g. DIAMOND)"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                              For Month(s)
                            </label>
                            <input
                              type="number"
                              value={forMonth}
                              onChange={(e) => setForMonth(e.target.value)}
                              className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                              placeholder="Enter number of months"
                              min="1"
                            />
                          </div>
                          <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {loading ? "Processing..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {(activeTab === "history") && (
        <div className="overflow-x-auto p-4">
          {/* History Container - Dark Mode Added */}
          <div className="backdrop-blur-md bg-white/70 dark:bg-gray-800/90 rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px]">
            <div className="flex justify-end items-center space-x-2 space-y-4">
              <button
                onClick={handleRefresh}
                className="text-gray-900 dark:text-gray-300 p-2 rounded-md border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-blue-500 dark:hover:text-blue-400 transition-transform duration-500 hover:rotate-180"
                title="Refresh"
              >
                <FiRefreshCcw />
              </button>
            </div>

            {/* History Table - Dark Mode Added */}
            <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9] dark:border-gray-700">
              <thead className="bg-blue-50 dark:bg-gray-800 text-blue-800 dark:text-gray-200">
                <tr>
                  <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                    <div className="flex items-center justify-between gap-1">
                      Created
                    </div>
                  </th>
                  <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                    <div className="flex items-center justify-between gap-1">
                      Payment Id
                    </div>
                  </th>
                  <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                    <div className="flex items-center justify-between gap-1">
                      Subscription Amount
                    </div>
                  </th>
                  <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                    <div className="flex items-center justify-between gap-1">
                      Month
                    </div>
                  </th>
                  <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                    <div className="flex items-center justify-between gap-1">
                      Amount
                    </div>
                  </th>
                  <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                    <div className="flex items-center justify-between gap-1">
                      Status
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {historyData.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="min-w-[30px] text-center py-4 border border-[#94BBE9] dark:border-gray-700 text-gray-500 dark:text-gray-400">
                      {loading ? "Loading..." : "No history found"}
                    </td>
                  </tr>
                ) : (
                  Array.isArray(historyData) && historyData.map((row, idx) => (
                    <tr key={idx} className="border-b border-[#94BBE9] dark:border-gray-700 text-gray-700 dark:text-gray-300">
                      <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                        {new Date(row.created).toLocaleDateString()}
                      </td>
                      <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                        {row.payment_id}
                      </td>
                      <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                        {row.subscription_amount}
                      </td>
                      <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                        {row.months}
                      </td>
                      <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                        {`${row.subscription_amount} * ${row.months} = ${row.amount}`}
                      </td>
                      <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          row.status === "Success" || row.status === "Paid"
                            ? "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400"
                            : row.status === "Pending"
                            ? "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400"
                            : "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400"
                        }`}>
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default Payment